{
  "language": {
    "label": "Language",
    "select": "Select language"
  },
  "nav": {
    "howItWorks": "How it Works",
    "programmes": "Programmes",
    "pricing": "Pricing",
    "contact": "Contact Us",
    "admin": "Admin",
    "resources": "Parent Resources",
    "reviews": "Parent Reviews",
    "signIn": "Parent Sign In",
    "portal": "Parent Portal",
    "book": "Book Free Assessment",
    "terms": "Terms & Conditions",
    "refund": "Refund Policy",
    "privacy": "Privacy Notice",
    "tagline": "Premium online English for young learners"
  },
  "hero": {
    "title": "Online English classes for kids that build real speaking fluency, ages 4–12",
    "rating": "CELTA-certified teacher · English & Psychology graduate",
    "credential": "CELTA-certified teacher",
    "subtitleBefore": "Live English lessons for kids ages 4–12, with max 5 students per class and 80%+ active speaking time. Progress is mapped to our",
    "subtitleLink": "CEFR-aligned curriculum",
    "ctaPrimary": "Book Free Assessment",
    "ctaSecondary": "See enrolment pricing",
    "liveLesson": "Live lesson · Cohort A1",
    "imageAlt": "Three young children laughing and speaking during a live online English class for kids at Smart Word Labs"
  },
  "approach": {
    "heading": "Small groups. Big speaking confidence.",
    "link": "See how our method works step by step"
  },
  "programmes": {
    "heading": "Programmes by age & level",
    "intro": "Every enrolment begins with a free assessment and a written learning plan. Children are placed in a micro-cohort matched to their age band and CEFR level, while IELTS Mastery offers private one-on-one coaching for candidates of any age.",
    "cefrLabel": "CEFR alignment",
    "cefr": "CEFR {{level}}",
    "lessonLength": "Lesson length",
    "cohortSize": "Cohort size",
    "speakingTime": " · 80%+ speaking time",
    "explore": "Explore {{title}}",
    "exploreAria": "See full details of {{title}} for {{band}}",
    "bookAria": "Book a free English assessment for {{title}}, {{band}}",
    "book": "Book free assessment",
    "compareAll": "Compare all programmes in detail",
    "items": {
      "early-phonics-explorers": {
        "band": "Ages 4–6",
        "title": "Early Phonics Explorers",
        "summary": "Live online English classes for kids aged 4–6: synthetic phonics, first words and speaking confidence in a micro-cohort of five.",
        "duration": "30-minute lessons",
        "cohort": "Max 5 children",
        "spots": "Max 5 children per group"
      },
      "literacy-builders": {
        "band": "Ages 7–9",
        "title": "Literacy Builders",
        "summary": "Small group English tutoring for children aged 7–9 covering reading fluency, structured writing and everyday conversation, aligned to CEFR A1–A2.",
        "duration": "45-minute lessons",
        "cohort": "Max 5 children",
        "spots": "Max 5 children per group"
      },
      "confident-communicators": {
        "band": "Ages 10–12",
        "title": "Confident Communicators",
        "summary": "A CEFR English course for children aged 10–12 building essay writing, debate and interview skills ready for secondary school.",
        "duration": "45-minute lessons",
        "cohort": "Max 5 children",
        "spots": "Max 5 children per group"
      },
      "ielts-mastery": {
        "band": "All ages",
        "title": "IELTS Mastery 1-on-1",
        "summary": "Private IELTS coaching for Academic or General Training, with band-score strategy, mock speaking tests and detailed writing feedback.",
        "duration": "45-minute lessons",
        "cohort": "One-on-one",
        "spots": "Private 1-on-1"
      }
    }
  },
  "pricing": {
    "heading": "Simple monthly pricing",
    "headingPage": "Pricing for online English classes for kids",
    "intro": "One monthly fee per child, billed monthly and cancellable any time. The assessment lesson and learning plan are always free.",
    "introTeaser": "One monthly fee per child, billed monthly and cancellable any time. The free assessment and written learning plan are included with every plan.",
    "mostPopular": "Most popular",
    "perMonth": "USD / month",
    "perLesson": "${{amount}} USD per lesson",
    "subscribe": "Subscribe",
    "signInToSubscribe": "Sign in to subscribe",
    "seeMore": "See what each plan includes on the pricing page",
    "noteLessonLength": "Lesson length varies by age group: 30 minutes for ages 4–6, 45 minutes for ages 7–12.",
    "noteCohorts": "Lessons run at 9, 10 and 11am and 2, 3, 4, 5 and 6pm Toronto time (ET). Your exact slot is confirmed during the free assessment.",
    "noteSibling": "Sibling enrolment saves 10% on every additional child. Prices in USD.",
    "tiers": {
      "cohort_starter_monthly": {
        "name": "Cohort Starter",
        "lessons": "8 lessons / month",
        "cadence": "2 lessons per week",
        "features": [
          "Micro-cohort of max 5 children",
          "45-minute live lessons, 2x per week",
          "Weekly homework with teacher feedback",
          "Monthly CEFR progress report",
          "Direct messaging with Ms. Salma",
          "2 reschedule credits each month"
        ]
      },
      "cohort_intensive_monthly": {
        "name": "Cohort Intensive",
        "lessons": "16 lessons / month",
        "cadence": "4 lessons per week",
        "features": [
          "Micro-cohort of max 5 children",
          "45-minute live lessons, 4x per week",
          "Weekly homework with teacher feedback",
          "Monthly CEFR progress report",
          "Direct messaging with Ms. Salma",
          "4 reschedule credits each month",
          "Priority cohort placement"
        ]
      },
      "private_1on1_monthly": {
        "name": "Private 1-on-1",
        "lessons": "16 lessons / month",
        "cadence": "4 lessons per week",
        "features": [
          "One-on-one lessons, no cohort — fully personalised curriculum",
          "45-minute live lessons, 4x per week",
          "Weekly homework with teacher feedback",
          "Monthly CEFR progress report",
          "Direct messaging with Ms. Salma",
          "Flexible rescheduling (no monthly cap)",
          "Custom pacing built around the child's goals"
        ]
      },
      "ielts_mastery_1on1_monthly": {
        "name": "IELTS Mastery 1-on-1",
        "lessons": "16 lessons / month",
        "cadence": "4 lessons per week",
        "features": [
          "Open to all ages — no upper age limit",
          "Targeted preparation for Academic or General IELTS",
          "One-on-one lessons, no cohort — personalized target band score strategy",
          "45-minute live intensive sessions covering Speaking, Reading, Writing & Listening",
          "Detailed IELTS Task 1 & Task 2 writing evaluations with band score feedback",
          "Live 1-on-1 Speaking mock tests & examiner-style feedback",
          "Targeted Reading & Listening practice with error analysis & time-management techniques",
          "Direct messaging with Ms. Salma",
          "Flexible rescheduling (no monthly cap)",
          "Custom pacing built around your target exam date"
        ]
      },
      "starter_pack_onetime": {
        "name": "Starter Pack",
        "lessons": "4 private 1-on-1 lessons",
        "cadence": "30 minutes each",
        "features": []
      }
    },
    "oneTime": "USD one-time",
    "getStarterPack": "Get the Starter Pack",
    "starterNote": "Try 4 lessons before committing. If you enrol within 30 days, the full $79 is credited to your first month."
  }
}
